import { render, staticRenderFns } from "./productSales.vue?vue&type=template&id=0c87af54"
import script from "./productSales.vue?vue&type=script&lang=js"
export * from "./productSales.vue?vue&type=script&lang=js"
import style0 from "./productSales.vue?vue&type=style&index=0&id=0c87af54&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports